import { useEffect, useState } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// react-router components
import { Link } from "react-router-dom";

// @mui material components
import Container from "@mui/material/Container";
import Icon from "@mui/material/Icon";

// Vero Software components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import ThemedLogo from "components/ThemedLogo";

// Images
import VeroLogo from "assets/images/VeroLogo.png";
import VeroLogoDark from "assets/images/VeroLogo-dark.png";

function VeroNavbar({ routes }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  // Close the mobile menu whenever the viewport grows back to desktop size
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth >= 992) setMobileOpen(false);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const closeMobile = () => setMobileOpen(false);

  return (
    <Container sx={{ position: "sticky", top: 0, zIndex: 10 }}>
      <MKBox
        py={1}
        px={{ xs: 2, sm: 3 }}
        my={2}
        width="100%"
        borderRadius="xl"
        shadow="md"
        sx={({ palette: { surface }, functions: { rgba } }) => ({
          backgroundColor: rgba(surface.main, 0.85),
          backdropFilter: "saturate(200%) blur(30px)",
        })}
      >
        <MKBox display="flex" justifyContent="space-between" alignItems="center">
          <MKBox component={Link} to="/" lineHeight={1} py={0.5}>
            <ThemedLogo light={VeroLogo} dark={VeroLogoDark} alt="Vero Software" height={36} />
          </MKBox>

          <MKBox display={{ xs: "none", lg: "flex" }} alignItems="center" ml="auto" gap={1}>
            {routes.map(({ name, route }) => (
              <MKButton
                key={name}
                component={Link}
                to={route}
                variant="gradient"
                color="info"
                size="small"
              >
                {name}
              </MKButton>
            ))}
            <MKButton component={Link} to="/contact" variant="gradient" color="info" size="small">
              Contact
            </MKButton>
          </MKBox>

          <MKBox
            display={{ xs: "inline-block", lg: "none" }}
            lineHeight={0}
            py={1}
            color="dark"
            sx={{ cursor: "pointer" }}
            onClick={() => setMobileOpen((open) => !open)}
          >
            <Icon fontSize="default">{mobileOpen ? "close" : "menu"}</Icon>
          </MKBox>
        </MKBox>

        {mobileOpen && (
          <MKBox display={{ xs: "flex", lg: "none" }} flexDirection="column" gap={1} pt={1} pb={2}>
            {routes.map(({ name, route }) => (
              <MKButton
                key={name}
                component={Link}
                to={route}
                onClick={closeMobile}
                variant="gradient"
                color="info"
                size="small"
              >
                {name}
              </MKButton>
            ))}
            <MKButton
              component={Link}
              to="/contact"
              onClick={closeMobile}
              variant="gradient"
              color="info"
              size="small"
            >
              Contact
            </MKButton>
          </MKBox>
        )}
      </MKBox>
    </Container>
  );
}

VeroNavbar.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      route: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default VeroNavbar;
